<template>
	<div class="travel-content">
		<div class="content">
			<div class="cases-type">
				<div class="title">案件类别</div>
				<div class="cases-content" @click="clickShowBottomWin('isShowTypeSelect')">
					<span :class="typeShowValue == '请选择案件类别' ? '' : 'selectColor'">{{typeShowValue}}</span>
					<img class="cases-img" :src="require('../../../assets/appraise/arrow_right.png')" />
				</div>
			</div>

			<div class="cases-level">
				<div class="title">案件级别</div>
				<div class="cases-content">
					<radio-group class="radioclass" v-model="radio" direction="horizontal">
						<radio name="big" checked-color="#07c160">
              <template #icon="props">
                  <img v-if="props.checked" style="width: 18px;" src="@/assets/appraise/active.jpg" alt="">
                  <img v-else-if="!props.checked" style="width: 18px;" src="@/assets/appraise/inactive.jpg" alt="">
                </template>
              涉旅案件
              </radio>
						<radio name="bigger" checked-color="#07c160">
              <template #icon="props">
                  <img v-if="props.checked" style="width: 18px;" src="@/assets/appraise/active.jpg" alt="">
                  <img v-else-if="!props.checked" style="width: 18px;" src="@/assets/appraise/inactive.jpg" alt="">
                </template>
                较大涉旅案件</radio>
					</radio-group>
				</div>
			</div>

			<div class="cases-link">
				<div class="title">案件链接</div>
				<linkCom v-model="websiteVOS"></linkCom>
				<div class="add-link">
					<addBtn value="新增链接" @addbtnClick="clickShowBottomWin('isShowAddLink')"></addBtn>
				</div>
			</div>

			<div class="add-file">
				<div class="title">相关材料</div>
                <!-- <div class="file_item" v-for="(item,index) in fileResVOS" :key="item.id">
                    <div class="file_msg">
                        <img src="@/assets/appraise/ic_pdf.png" alt />
                        <p class="file_name">
                        <span>{{item.fileName}}.{{item.fileType}}</span>
                        </p>
                    </div>
                    <div class="delImg" @click="delFile(index)">
                        <img src="@/assets/appraise/delete.png" alt="" />
                    </div>
                    <div class="file_size">{{item.fileSize}}</div>
                </div> -->
				<materiascience :caseList="fileResVOS" @deleteFiel="delFile"></materiascience>
				<div class="file-content">
					<addBtn v-if="fileResVOS.length < 10" :isShowSpan="true" :isGoAndroidandIOS="true" :needEmit="true" @fields="getFiles"></addBtn>
				</div>
			</div>

			<div class="remarks">
				<div class="title">备注</div>
				<div class="remarks-text">
					<textarea maxlength="500"  v-model="remark" placeholder="请输入备注"></textarea>
				</div>
			</div>
		</div>

		<div class="footer-dv">
			<cusBtn2 value="保存" @click="save"></cusBtn2>
		</div>
        <!-- 案件类别选择 -->
		<bottomCheckbox v-show="isShowTypeSelect" @onConfirm="confirmTypeSelect" @onClose="isShowTypeSelect = false"></bottomCheckbox>
        <!-- 案件链接 -->
        <addLink v-if="isShowAddLink" @onConfirm="confirmAddLink" @onClose="isShowAddLink = false"></addLink>

        <tipDialog v-if="showDialog" :content="dialogTitle" @closeModal="showDialog = false"></tipDialog>

	</div>
</template>
<script>
import { RadioGroup, Radio } from "vant";
import API from "../../../service/index";
import addBtn from "./components/addBtn";
import cusBtn2 from "./components/cusBtn2";
import linkCom from "./components/linkCom";
import addLink from "./components/addLink";
import bottomCheckbox from "./components/bottomCheckbox";
import confirmDialog from "../components/confirmDialog.vue";
import tipDialog from "./components/tipDialog.vue";
import icon from "@/assets/appraise/icon_ts_gx@3x.png";
import materiascience from './components/materialScience_delete.vue'
export default {
	name: "travelCases",
	components: {
		addBtn,
		cusBtn2,
		linkCom,
        addLink,
        bottomCheckbox,
        RadioGroup,
        Radio,
        // confirmDialog,
		tipDialog,
		materiascience
	},
	data() {
		return {
            /** 提示弹窗 **/
			isShowTipDialog: false,
			tipDialogContent: "已达到上限",
            showDialog: false,
            isShowHistoryLink: false, // 案件链接是否显示
            isShowTypeSelect: false, // 案件类别是否显示
            isShowAddLink: false, // 案件链接是否显示
            routeQuery: {}, // 路由上的参数
            infoData: {}, // 存放信息的对象
            currentInfo: [], // 当前附件信息的对象
			placehodlervalue: [], // 案件类别存放
            radio: '', // 案件级别
            websiteVOS: [], // 案件链接存放
            fileResVOS: [], // 附件存放
            remark: '', // 备注
		};
    },
    created() {
        /** 获取路由参数 **/
        this.routeQuery = this.$route.query;
        this.getInfo();
    },
    computed: {
        typeShowValue() {
			// console.log('----编辑和新增的区别：', this.placehodlervalue.map(e => e.text).join(','));
            return this.placehodlervalue.length == 0 ? '请选择案件类别' : this.placehodlervalue.map(e => e.text).join(',');
        }
    },
	methods: {
        /** 获取信息 **/
        async getInfo() {
            const res = await API.getDetailByA3({
                monitorType: this.routeQuery.monitorType,
                area: this.routeQuery.area,
                quarter: this.routeQuery.quarter,
                year: this.routeQuery.year,
            });
            if ( res.ret === 0 ) {
                this.infoData = res.data;

                if ( this.routeQuery.code ) {
                    this.currentInfo = res.data.areaTripCaseDetailVO.filter(e => e.areaTripCaseVO.batchCode == this.routeQuery.code)[0];
                    /** 案件类别处理 **/
					const caseType = this.currentInfo.areaTripCaseVO.caseType.split(',');
					let a = this.currentInfo.areaTripCaseVO.caseTypeCN.split('：');
					let b = this.currentInfo.areaTripCaseVO.caseTypeCN.split(':');
					// let caseTypeCN = this.currentInfo.areaTripCaseVO.caseTypeCN.split('：');
					let caseTypeCN = null;
					if( b.length > a.length ){
                      caseTypeCN = b;
					}else{
					  caseTypeCN = a;
					}
                    const caseTypeId = this.currentInfo.areaTripCaseVO.id.split(',');
					const caseTypeCNHandle = caseTypeCN.length > 1 ? caseTypeCN[1].split(',') : caseTypeCN[0];
					// console.log('-----caseCN:', caseTypeCN);
					// console.log('----caseTYPEcnHANDL：', caseTypeCNHandle);
					/** 案件类别 默认展示 **/
					// this.placehodlervalue = caseTypeCNHandle;
                    this.placehodlervalue = caseType.map((e,index) => {
                        return {
                            id: caseTypeId[index],
                            value: e,
                            text: Array.isArray(caseTypeCNHandle) ? caseTypeCNHandle[index] : caseTypeCNHandle,
                        }
                    });
                    /** 案件链接 **/
                    this.websiteVOS = this.currentInfo.websiteVOS;
                    /** 案件级别 **/
                    this.radio = this.currentInfo.areaTripCaseVO.caseLevel;
                    /** 附件 **/
                    this.fileResVOS = this.currentInfo.fileResVOS || [];
                    /** 备注 **/
                    this.remark = this.currentInfo.areaTripCaseVO.caseDesc;
                }

            }
        },
        /** 显示案件链接 **/
        clickShowHistoryLink() {
            this.isShowHistoryLink = true;
        },
        /** 显示底部窗口 **/
        clickShowBottomWin(name) {
            if ( name == 'isShowAddLink' && this.websiteVOS.length >= 10 ) {
                this.isShowTipDialog = true;
                return;
            }
            this[name] = true;
        },
        /**
         * @description: 确实选中案件类别
         * @param { arr } array 选中的案件类别，可多选
         */
        confirmTypeSelect(arr) {
            this.placehodlervalue = arr.map( e => ({
                value: e.id,
                text: e.text
            }));
        },
        /**
         * @description: 确实添加链接
         * @param { link } String 输入的链接
         */
        confirmAddLink(link) {
            this.websiteVOS.push({
                caseUrl: link
            });
        },
        /** 上传文件 **/
        getFiles(file) {
            this.fileResVOS.push(file[0]);
        },
        /** 删除文件 **/
        delFile(index) {
            this.fileResVOS.splice(index, 1);
        },
        /** 保存按钮 **/
        async save() {
            if(this.placehodlervalue.length==0) {
              this.showDialog = true;
              this.dialogTitle = "请选择案件类别"
              return
            }
            if(this.radio=='') {
              this.showDialog = true;
              this.dialogTitle = "请选择案件级别"
              return
            }
            if(this.websiteVOS.length==0) {
              this.showDialog = true;
              this.dialogTitle = "请新增案件链接"
              return
            }
            if(this.fileResVOS.length==0) {
              this.showDialog = true;
              this.dialogTitle = "请新增相关附件"
              return
            }
            const obj = {
                id: this.infoData.id || '',
                batchCode: this.routeQuery.code || '',
                fileResVOS: this.fileResVOS,
                websiteVOS: this.websiteVOS,
                tripCaseVOS: this.placehodlervalue.map(e => ({
                    caseDesc: this.remark,
                    caseLevel: this.radio,
                    caseType: e.value || '',
                    id: e.id || '',
                })),
                monitorType: this.routeQuery.monitorType,
                quarter: this.routeQuery.quarter,
                year: this.routeQuery.year,
            };
            const res = await API.uploadByLawCaseA3(obj);
            if ( res.ret === 0 ) {
                this.$Toast({
                    message: '保存成功',
                    icon
                });
               setTimeout(() => {
                   this.$router.back(-1);
               }, 1000)
            }
            console.log(obj);
        },
	},
};
</script>
<style lang="less" scoped>
.travel-content {
	width: 100%;
	min-height: 100%;
	position: relative;
    // overflow-y: auto;
    padding-bottom: 70px;
	.content {
		width: 100%;
		height: 100%;
		padding: 0 12px;
        overflow: hidden;
		.cases-type {
			width: 100%;
			height: 46px;
			display: flex;
			justify-content: space-between;
			overflow: hidden;
			.title {
				width: 100px;
				height: 46px;
				line-height: 46px;
				font-size: 14px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: rgba(102, 102, 102, 1);
            }
			.cases-content {
				height: 46px;
				line-height: 46px;
				display: flex;
				justify-content: flex-end;
				align-items: center;
				span {
					font-size: 14px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: rgba(204, 204, 204, 1);
                }
                .selectColor {
                    color: #333;
                }
				.cases-img {
					width: 12px;
					height: 12px;
					margin-left: 4px;
				}
			}
		}
		.cases-type::after {
			content: "";
			position: absolute;
			top: 46px;
			width: 93%;
			height: 1px;
			background-color: #e5e5e5;
			overflow: hidden;
			transform: scaleY(0.5);
		}
		.cases-level {
			width: 100%;
			height: 46px;
			display: flex;
			justify-content: space-between;
			overflow: hidden;
			position: relative;
			.title {
				width: 100px;
				height: 46px;
				line-height: 46px;
				font-size: 14px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: rgba(102, 102, 102, 1);
			}
			.cases-content {
				width: 220px;
				height: 46px;
				line-height: 46px;
				display: flex;
				justify-content: flex-end;
				align-items: center;
				position: absolute;
				right: -10px;
			}
		}
		.cases-level::after {
			content: "";
			position: absolute;
			top: 45.5px;
			width: 100%;
			height: 1px;
			background-color: #e5e5e5;
			overflow: hidden;
			transform: scaleY(0.5);
		}
		.cases-link {
			width: 100%;
			position: relative;
			.title {
				width: 100px;
				height: 46px;
				line-height: 46px;
				font-size: 14px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: rgba(102, 102, 102, 1);
			}
			.add-link {
				width: 100%;
				margin-top: 16px;
				display: block;
			}
		}
		.cases-link::after {
			content: "";
			position: absolute;
			bottom: -16px;
			width: 100%;
			height: 1px;
			background-color: #e5e5e5;
			overflow: hidden;
			transform: scaleY(0.5);
		}

		.add-file {
			width: 100%;
			margin-top: 16px;
			position: relative;
			.title {
				width: 100px;
				height: 46px;
				line-height: 46px;
				font-size: 14px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: rgba(102, 102, 102, 1);
			}
			.file-content {
				width: 100%;
			}
		}
		.add-file::after {
			content: "";
			position: absolute;
			bottom: -16px;
			width: 100%;
			height: 1px;
			background-color: #e5e5e5;
			overflow: hidden;
			transform: scaleY(0.5);
			z-index: -9;
		}
		.remarks {
			width: 100%;
			margin-top: 16px;
			.title {
				width: 100px;
				height: 46px;
				line-height: 46px;
				font-size: 14px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: rgba(102, 102, 102, 1);
			}
			.remarks-text {
				width: 100%;
				height: 105px;
				background: rgba(245, 245, 245, 1);
				border-radius: 3px;
				padding: 16px 12px;
				textarea {
					outline: none;
					border: none;
					resize: none;
					width: 100%;
					height: 100%;
					background: rgba(245, 245, 245, 1);
				}
			}
		}
	}

	.footer-dv {
		width: 100%;
		height: 60px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.03);
		position: fixed;
		bottom: 0;
		padding: 10px 12px;
    }
    .file_item {
        display: flex;
        box-sizing: border-box;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 37px;
        .file_msg {
            flex: 1;
            display: flex;
            align-items: center;
        }
        .file_msg img {
            margin-right: 12px;
            width: 34px;
            height: 38px;
        }
        .file_msg p {
            font-size: 14px;
            color: #333;
            span {
                line-height: 20px;
                word-wrap:break-word;
            }
        }
        .file_size {
            font-size: 12px;
            color: #999;
        }
        .delImg {
            box-sizing: border-box;
            line-height: 38px;
            margin-left: 5px;
            margin-right: 10px;
        }
        .delImg img {
			width: 15px;
			height: 16px;
        }
    }
}
</style>
